<!-- Start Footer Area -->
<footer class="footer-area">
    <div
        class="container-fluid"
        style="padding-left: 156px; padding-right: 156px"
    >
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a href="#"
                            ><img src="assets/img/vocbot-logo-footer.jpeg" alt="image" style="width: 200px;"
                        /></a>
                        <p>
                            Multi-lingual SaaS based,<br />
                            AI driven contact center
                        </p>
                    </div>

                    <ul class="social mt-3">
                        <li>
                            <a
                                href="https://www.facebook.com/profile.php?id=100095436315965&mibextid=ZbWKwL"
                                target="_blank"
                                ><i class="flaticon-facebook-letter-logo"></i
                            ></a>
                        </li>
                        <!-- <li>
                            <a href="#" target="_blank"
                                ><i class="flaticon-twitter-black-shape"></i
                            ></a>
                        </li> -->
                        <li>
                            <a
                                href="https://www.instagram.com/vocbot.ai?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                target="_blank"
                                ><i class="flaticon-instagram-logo"></i
                            ></a>
                        </li>
                        <li>
                            <a
                                href="https://www.linkedin.com/company/vocbot-ai/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B3yVV95aQSDazlBEFqTDLdQ%3D%3D"
                                target="_blank"
                                ><i class="flaticon-linkedin-letters"></i
                            ></a>
                        </li>
                        <!-- <li>
                            <a href="#" target="_blank"
                                ><i class="flaticon-youtube"></i
                            ></a>
                        </li> -->
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="single-footer-widget">
                    <h3>Services</h3>

                    <ul class="footer-services-list">
                        <li>
                            <a routerLink="/inBound" (click)="onLinkClick($event,'inBound')">Inbound Call Center</a>
                        </li>
                        <li>
                            <a routerLink="/outBound" (click)="onLinkClick($event,'outBound')">Outbound Marketing</a>
                        </li>
                        <li>
                            <a routerLink="/bulkWhatsApp" (click)="onLinkClick($event,'bulkWhatsApp')"
                                >WhatsApp Sender</a
                            >
                        </li>
                     
                        <li>
                            <a routerLink="/bulk-sms-sender" (click)="onLinkClick($event,'bulk-sms-sender')">Bulk Messenger</a>
                        </li>
                        <li> <a  routerLink="/email"  (click)="onLinkClick($event,'email')">Email</a></li>
                        <li><a  routerLink="/whatsapp-meta"  (click)="onLinkClick($event,'whatsapp-meta')">Whatsapp Meta</a></li>
                        <li><a  routerLink="/rcs"  (click)="onLinkClick($event,'rcs')">RCS</a></li>
                        <li><a  routerLink="/ivr"  (click)="onLinkClick($event,'ivr')">OBD / IVR</a></li>
                       
                    </ul>
                </div>
                <div class="others-options">
                    <a
                        routerLink="/book-demo" (click)="onLinkClick($event,'book-demo')"
                        class="btns btn-primarys btnwidth mb-4">
                        Book a Demo
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="single-footer-widget">
                    <h3>Quick Links</h3>

                    <ul class="quick-links-list">
                        <li>
                            <a routerLink="/about-us" (click)="onLinkClick($event,'about-us')">About Us</a>
                        </li>
                        <li>
                            <a routerLink="/plans" (click)="onLinkClick($event,'plans')">Plans</a>
                        </li>
                        <li>
                            <a routerLink="/contact" (click)="onLinkClick($event,'contact')">Contact Us</a>
                        </li>
                        <li>
                            <a routerLink="/partners" (click)="onLinkClick($event,'partners')"> Partners </a>
                        </li>
                        <li>
                            <a routerLink="/faq" (click)="onLinkClick($event,'faq')"> FAQs </a>
                        </li>
                        <li>
                            <a routerLink="/privacy" (click)="onLinkClick($event,'privacy')">Privacy Policy</a>
                        </li>
                        <li>
                            <a routerLink="/terms"  (click)="onLinkClick($event,'terms')">Terms & Conditions</a>
                        </li>
                        <li>
                            <a routerLink="/refund-policy" (click)="onLinkClick($event,'refund-policy')">Refund Policy</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="single-footer-widget">
                    <h3>Contact Us</h3>

                    <ul class="footer-contact-list">
                        <li>
                            <span>Address:&nbsp;</span> 43, Pratap Nagar, 
                            <!-- <br>
                            Roop Ram Nagar, -->
                            <br>
                            Near Manik Bagh Road,
                            <br>
                            Indore (M.P.) 452007
                        </li>
                        <li>
                            <span>Email:&nbsp;</span>
                            <a href="mailto:info@vocbot.ai">info@vocbot.ai</a>
                        </li>
                        <li>
                            <span> Phone:&nbsp; </span>
                            <a href="tel:+91-9826323332"> +91-9826323332 </a>
                        </li>
                        <!-- <li><span>Fax:</span> <a href="#">+44 785 4578964</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="circle-map">
        <img src="assets/img/circle-map.png" alt="image" />
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>

<!-- Copyright Section -->
<div class="copyright-area">
    <div
        class="container-fluid"
        style="padding-left: 100px; padding-right: 100px"
    >
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <p>
                    Copyright &copy; {{ currentYear }}
                    <a href="#"> Vocbot.Ai Technology Private Limited </a>
                    . All Rights Reserved.
                </p>
            </div>
        </div>
    </div>
</div>

<!-- End Footer Area -->
<div class="go-top">
    <i class="fas fa-arrow-up"></i><i class="fas fa-arrow-up"></i>
</div>
